export default class ServisMarkup {
  id: number = 0;
  serviceId: number = 0;
  service: any = null;
  percentageMarkup: number = 0;
  fixedMarkup: number = 0;
  currencyId: string = "";
} 